// routes/page-template-blog

import Filters from "../components/filter";
// import Instagram from "../components/instagram";

export default {
    init() {
        this.Filters = new Filters();
        // new Instagram();
    },
    finalize() {},
};



// WEBPACK FOOTER //
// ./js/routes/page-template-blog.js